import { apiFetch } from "../utils/apiFetch";
import { API_BASE_OPERATOR as API_BASE } from "../config/vars";

const readErrorMessage = async (res, fallback) => {
    try {
        const data = await res.json();
        return data?.detail || data?.message || fallback;
    } catch {
        try {
            const txt = await res.text();
            return txt || fallback;
        } catch {
            return fallback;
        }
    }
};

export const fetchClientMultiLocations = async (clientId) => {
    const res = await apiFetch(`${API_BASE}/clients/operator/${clientId}/multi_locations`);
    if (!res.ok) throw new Error(await readErrorMessage(res, "Не вдалося завантажити мульти-локації"));
    return await res.json();
};

export const addClientMultiLocation = async (clientId, data) => {
    const res = await apiFetch(`${API_BASE}/clients/operator/${clientId}/multi_locations`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
    });
    if (!res.ok) throw new Error(await readErrorMessage(res, "Не вдалося створити мульти-локацію"));
    return await res.json();
};

export const updateClientMultiLocation = async (recordId, data, source = null) => {
    const params = source ? `?source=${encodeURIComponent(source)}` : "";
    const res = await apiFetch(`${API_BASE}/clients/operator/multi_locations/${recordId}${params}`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
    });
    if (!res.ok) throw new Error(await readErrorMessage(res, "Не вдалося оновити мульти-локацію"));
    return await res.json();
};

export const deleteClientMultiLocation = async (recordId, source = null) => {
    const params = source ? `?source=${encodeURIComponent(source)}` : "";
    const res = await apiFetch(`${API_BASE}/clients/operator/multi_locations/${recordId}${params}`, {
        method: "DELETE",
    });
    if (!res.ok) throw new Error(await readErrorMessage(res, "Не вдалося видалити мульти-локацію"));
    return await res.json();
};
